import sanitize from '@/plugins/filters/mask/sanitize'

export default function (value) {
  const number = sanitize(value)
  if (number === undefined) {
    return 'NaN'
  }
  return new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW' }).format(value)
}
